import { Box, Stack, TextField } from '@mui/material';
import { useEffect, useState } from 'react';

export enum EmailBodyVariableEnum {
  FORM_ID = '{{form_id}}',
  FORM_TITLE = '{{form_title}}',
  EMAIL = '{{email}}',
  FIRST_NAME = '{{first_name}}',
  LAST_NAME = '{{last_name}}',
  FORM_DATA = '{{form_data}}',
  FORM_URL = '{{form_url}}',
  FORM_SETTINGS_URL = '{{form_settings_url}}',
}

type State = {
  subject?: string;
  body?: string;
};

export const EmailComposer = (props: { subject?: string; body?: string; onChange: (value: State) => void }) => {
  const [state, setState] = useState({
    subject: props?.subject,
    body: props?.body,
  });

  useEffect(() => {
    setState({
      subject: props?.subject,
      body: props?.body,
    });
  }, [props]);

  useEffect(() => {
    props?.onChange?.(state);
  }, [JSON.stringify(state)]);

  return (
    <Box>
      <Stack direction="column" spacing={2} sx={{ m: '1em 0' }}>
        {/* subject */}
        <TextField
          fullWidth
          label="Subject"
          variant="outlined"
          value={state.subject}
          onChange={({ target: { value } }) => {
            setState((prev) => ({ ...prev, subject: value }));
          }}
        />
        {/* body */}
        <TextField
          fullWidth
          value={state.body}
          onChange={({ target: { value } }) => {
            setState((prev) => ({ ...prev, body: value }));
          }}
          label="Body"
          variant="outlined"
          multiline
          rows={8}
          helperText={`Available Variables: ${Object.keys(EmailBodyVariableEnum)
            .map((key) => EmailBodyVariableEnum[key as keyof typeof EmailBodyVariableEnum])
            .join(', ')}`}
        />
      </Stack>
    </Box>
  );
};

export default EmailComposer;
